import { formatEventEntry } from "../../../domain/managedEvent";

const toManagedEvent = (row) => ({
  eventTitle: row.event_title,
  eventType: row.event_type,
  dateType: row.date_type,
  nextEventTime: row.next_event_time,
  eventStartDate: row.event_start_date,
  eventEndDate: row.event_end_date,
  timeZone: row.time_zone,
  timeZoneAbbr: row.time_zone_abbr,
  hasTime: Boolean(row.has_time),
});

const toEventEntry = (row) => formatEventEntry(toManagedEvent(row));

const nextBatchSummary = (entry) =>
  entry ? `Next batch · ${entry.month} ${entry.day}` : "No batches scheduled";

export { nextBatchSummary, toEventEntry };
